module.exports = __webpack_public_path__ + "static/city_icon_109-6473913d75758124df8d067ace210a6e.png";